<template>
    <div v-if="pageData" class="about-page">
        <div class="result-hero-wrapper hero" v-if="pageData.hero_title && pageData.hero_synopsis">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="heading-container d-flex">
                            <h1 class="d-flex">{{ pageData.hero_title }}</h1>
                        </div>

                        <div class="content" v-html="pageData.hero_synopsis"></div>
                    </div>
                </div>
            </div>

            <div class="container stat-container">
                <div class="row">
                    <div class="col-12 col-lg-4" v-for="stat in stats" :key="stat.title">
                        <div class="stat d-flex align-items-center">
                            <div class="icon">
                                <component v-bind:is="componentName(stat.icon)"></component>
                            </div>
                            <div class="body">
                                <div class="stat-title">{{ stat.title }}</div>
                                <div class="stat-body">{{ stat.body }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container about-cta-section">
            <div class="row">
                <div class="col-12 col-lg-8" v-html="pageData.content"></div>
                <div class="col-12 col-lg-4 d-flex align-items-center">
                    <router-link :to="{ name: 'apply' }" class="btn button secondary">
                        {{ $t('heroForm.submit') }}
                    </router-link>
                </div>
            </div>
        </div>

        <PrivacyOptOut v-if="pageData.template == 'privacy_policy'" />
    </div>
</template>

<script>
import { url } from '@js/utilities/url.js'
import { useStore } from 'vuex'

// lodash components
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

export default {
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    created() {
        this.emitter.on('pageData:loaded', () => {
            // Listen for loaded event once
            this.emitter.off('pageData:loaded')
        })
    },
    methods: {
        componentName(icon) {
            return `About${upperFirst(camelCase(icon))}`
        },
    },
    computed: {
        pageData: function () {
            if (this.store.state.global.page) {
                this.emitter.emit('pageData:loaded')

                return this.store.state.global.page
            }

            return null
        },
        stats: function () {
            if (this.pageData.stats) {
                return JSON.parse(this.pageData.stats)
            }

            return false
        },
        heroImage: function () {
            return this.asset('img/backgrounds/background-about-2048x1368.jpg')
        },
    },
    menuMisc: function () {
        return this.menu.misc || {}
    },
}
</script>

<style lang="scss">
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.hero {
    background-position: center;
    background-size: cover;
    display: flex;
    padding-bottom: 144px;
    padding-top: 32px;
    position: relative;
    width: 100%;

    @media screen and (min-width: $bp-large) {
        padding-top: 72px;
    }

    .heading-container {
        margin-bottom: 9px;
        flex-wrap: wrap;
        justify-content: flex-start;

        @media screen and (min-width: $bp-large) {
            justify-content: space-between;
        }

        h1 {
            color: var(--hero-text);
            font-family: var(--heading-font);
            font-size: rem(46px);
            font-weight: 700;
        }
    }

    .content {
        color: var(--hero-text);
        font-family: var(--heading-font);
        padding-bottom: 100px;

        @media screen and (min-width: $bp-large) {
            padding: 0;
        }
    }

    .stat-container {
        bottom: 0;
        left: 50%;
        position: absolute;
        transform: translate(-50%, 50%);

        .stat {
            background-color: #ffffff;
            box-shadow: 0 0 2em 0 rgb(0 0 0 / 10%);
            height: 140px;
            margin-top: 16px;
            padding: 24px;

            @media screen and (min-width: $bp-large) {
                margin-top: 0;
            }

            .icon {
                margin-right: 16px;
                width: 82px;
            }

            .stat-title {
                color: var(--text-dark);
                font-family: var(--heading-font);
                font-size: rem(16px);
                font-weight: 600;
            }

            .stat-body {
                color: var(--text-dark);
                font-family: var(--heading-font);
                font-size: rem(42px);
                font-weight: 600;
                line-height: 1;
            }
        }
    }
}

.about-cta-section {
    margin-bottom: 100px;
    margin-top: 300px;

    @media screen and (min-width: $bp-large) {
        margin-top: 135px;
    }

    button {
        margin: 0 auto;
        width: auto;
    }
}
</style>

<style lang="scss">
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.about-page {
    .cls-1 {
        fill: var(--preloader-background-color);
    }

    .about-cta-section {
        h2 {
            font-size: rem(30px);
            font-weight: 600;
        }
    }
}
</style>
